export default {
  setActive: (state, obj) => {
    var children = obj.children.concat(obj.leaves);

    state.active = {
      father: obj.father,
      children: children
    }
  },
  setLastHeight: (state, obj) => {
    state.last_table_height = obj;
  },
  setCategory: (state, obj) => {
    state.category = obj;
  },
  setModel: (state, obj) => {
    state.model = obj;
  },
  setSelCat: (state, obj) => {
    state.selected_catalog = obj;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js